/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateWatchlistCommand } from '../../models/create-watchlist-command';
import { WatchlistModelResult } from '../../models/watchlist-model-result';

export interface ApiWatchlistCreatePost$Plain$JsonOdataMetadataFullOdataStreamingTrue$Params {
      body?: CreateWatchlistCommand
}

export function apiWatchlistCreatePost$Plain$JsonOdataMetadataFullOdataStreamingTrue(http: HttpClient, rootUrl: string, params?: ApiWatchlistCreatePost$Plain$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<WatchlistModelResult>> {
  const rb = new RequestBuilder(rootUrl, apiWatchlistCreatePost$Plain$JsonOdataMetadataFullOdataStreamingTrue.PATH, 'post');
  if (params) {
    rb.body(params.body, 'text/plain');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json;odata.metadata=full;odata.streaming=true', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WatchlistModelResult>;
    })
  );
}

apiWatchlistCreatePost$Plain$JsonOdataMetadataFullOdataStreamingTrue.PATH = '/api/watchlist/create';
